import { Component } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { AlertController, MenuController, NavController } from "@ionic/angular";
import { UserService } from "src/app/services/firebase/user.service";
import { MessagesService } from "src/app/services/messages.service";
import { environment } from "src/environments/environment";
import { LoginModel } from "../../classes/login.model";
import { AuthService } from "../../services/auth.service";
import { AuthRepository } from "../../state/auth.repository";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {

  loginForm: UntypedFormGroup
  token$: any
  prod: boolean

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private authRepo: AuthRepository,
    private router: Router,
    private navCtrl: NavController,
    private menuController: MenuController,
    private alertCtrl: AlertController,
    private messagesService: MessagesService,
    private userService: UserService,
  ) {
    this.menuController.enable(false)
    this.prod = environment.production

    let login = new LoginModel()

    this.token$ = this.authRepo.token$
    this.loginForm = this.formBuilder.group({
      email: [login.email],
      password: [login.password],
    })
  }

  logout() {
    this.authService.logout()
  }

  setUser(user: string) {
    let login = new LoginModel()

    switch (user) {
      case '1':
        login = new LoginModel('user001', '00000001');
        break;
      case '2':
        login = new LoginModel('user002', '00000002');
        break;
    }

    this.loginForm = this.formBuilder.group({
      email: [login.email],
      password: [login.password],
    })
  }

  getUser() {
    // this.authService.user().subscribe(value => {
    // })
  }

  async onSubmit() {

    this.loginForm.markAllAsTouched()
    if (this.loginForm.invalid) return

    const payload = this.loginForm.value

    this.authService
      .login(payload)
      .then(user => {
        this.menuController.enable(false)
        this.navCtrl.navigateRoot('/')
      })

  }

  async presentAlertPrompt() {
    const alert = await this.alertCtrl.create({
      header: 'Redefinir senha',
      inputs: [
        {
          name: 'email',
          type: 'email',
          value: this.loginForm.value.email,
          placeholder: 'Email'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        }, {
          text: 'Redefinir',
          handler: data => {
            if (data.email.length == 0) {
              this.messagesService.alert({ message: "Email precisa ser informado" });
              return;
            }

            this.authService
              .forgot(data.email)
              .subscribe({
                next: () => this.messagesService.success(null, {
                  header: 'Email enviado com sucesso',
                  message: 'Verifique sua caixa de entrada'
                }),
                error: (err) => {
                  this.messagesService.alert({
                    message: "Houve um problema ao enviar seu email. Tente novamente mais tarde"
                  })
                }
              })
          }
        }
      ]
    });

    await alert.present();
  }

  loginAs(role) {
    switch (role) {
      case 'admin':
        this.loginForm.get('email').setValue('fgscaglioni@gmail.com')
        this.loginForm.get('password').setValue('5up3r@53cr3t')
        break;
      case 'manager':
        this.loginForm.get('email').setValue('amanda-raro1@hotmail.com')
        this.loginForm.get('password').setValue('fabricio')
        break;
      case 'doctor':
        this.loginForm.get('email').setValue('robertasvasquez@gmail.com')
        this.loginForm.get('password').setValue('secret')
        break;
      case 'reception':
        this.loginForm.get('email').setValue('email_8@test.com')
        this.loginForm.get('password').setValue('secret')
        break;
      case 'joao':
        this.loginForm.get('email').setValue('joaosilva@gmail.com')
        this.loginForm.get('password').setValue('jalksjdflajsdf')
        break;
    }
    this.onSubmit();
  }

  signup() {
    this.navCtrl.navigateForward('/register')
  }

}
